import type { FaireReviewEntity } from "../../entity_types/review";

// Real per-product review for Noble Mick's - Craft Beverage Company's
// "Lavender Lemonade Single Serve Craft Cocktail" (p_n2kkaxn53j), pulled
// from Faire's live `GET /api/product-reviews/product/{product_token}`
// endpoint (the same data source that powers the product's own PDP review
// list) — verbatim comment, real reviewer, real rating, real publish date.
export const review_nm5: FaireReviewEntity = {
  token: "review_nm5",
  type: "review",
  brandName: "Noble Mick's - Craft Beverage Company",
  brandToken: "b_kxk5df5zt5",
  productToken: "p_n2kkaxn53j",
  reviewType: "product",
  reviewerName: "Anne K.",
  reviewerLocation: "Scottsbluff, NE, United States",
  stars: 5,
  reviewText:
    "The singles fly off the shelves and make great gifts, stocking stuffers and are easy to mail!",
  reviewDate: "Nov 24, 2025",
  meta: {
    source: "api" as const,
    importedAt: "2026-08-11T21:06:39.000Z",
    importedBy: "entity-db-cli",
  },
};
